import React from 'react';
import PropTypes from 'prop-types';
import { handleImageError } from '../../utils/imageUtils';
import './InfoCard.css';

const InfoCard = ({
  image,
  imageAlt,
  title,
  subtitle,
  date,
  description,
  items,
  className = '',
  wide = false,
}) => {
  return (
    <article className={`card gallery__item ${wide ? 'gallery__item--wide' : ''} ${className}`}>
      <div className="text-center">
        {(image || title) && (
          <div className="card__header">
            {image && (
              <img
                src={image}
                className="card__image"
                alt={imageAlt || title || 'Card image'}
                onError={(e) => handleImageError(e)}
                loading="lazy"
              />
            )}
            {title && <h4 className="card__title">{title}</h4>}
            {subtitle && <h5 className="card__subtitle">{subtitle}</h5>}
            {date && <p className="card__date">{date}</p>}
          </div>
        )}
        
        {description && (
          <div className="card__content">
              {typeof description === 'string' ? (
                <p dangerouslySetInnerHTML={{ __html: description.replace(/\n/g, '<br />') }} />
              ) : (
                <p>{description}</p>
              )}
            </div>
          )}

          {items && items.length > 0 && (
            <ul className="card__list">
              {items.map((item, index) => (
                <p key={index} className="card__list-item">
                  {item}
                </p>
              ))}
            </ul>
          )}
        </div>
    </article>
  );
};

InfoCard.propTypes = {
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  imageAlt: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  date: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  items: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  wide: PropTypes.bool,
};

export default InfoCard;

